module.exports = __webpack_public_path__ + "sm.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/sm.svg
// module id = 1064
// module chunks = 0